import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { FaDownload } from "@react-icons/all-files/fa/FaDownload";
import { FaFileAlt } from "@react-icons/all-files/fa/FaFileAlt";
import ReporteServicioPublico from "../Modulos/ReporteServicioPublico";
import ModalReporteServicio from "../components/modals/modalReporteServicio";
import "./Css/publicReportes.css";

const PUBLIC_TOKEN_ENDPOINT = "/reportes/consultar-token";

const MOCK_CONTRACT_BASE = {
    Active: true,
    Ciudad: "Cartagena: Transversal 38",
    CiudadDestino: "Cartagena",
    CiudadOrigen: "Cartagena",
    ContadorGps: 0,
    ContainerNum: "GAOU7334947",
    ContractID: "SERV-00527974",
    DescripcionRuta: "Esenttia-  SOCIEDAD PORTUARIA",
    DescripcionTrayecto: null,
    DistanciaCompleta: 0,
    EsCritico: 1,
    FKICEmpresa: 360,
    FKLokDeviceID: "8041502038",
    FKLokProyecto: 18,
    FKLokSolicitud: "SOL-00000000",
    FKLokTipoEquipo: 9,
    IconBack: "/images/transparent.png",
    IconDesvio: "/images/transparent.png",
    IconLocked: "/images/candado.png",
    IconMoving: "/images/stop.png",
    IconSeguro: "/images/transparent.png",
    IconValitronics: "/images/valitronics_gris.png",
    IdEmpresa: 360,
    LastMsgLat: 10.40690484456718,
    LastMsgLong: -75.52707768045366,
    LastReportNota: null,
    LastReportUbica: null,
    LastReportgeocerca: 7272,
    Locked: false,
    LoksysServerTime: "2026-05-20T14:21:36.967Z",
    MovilConductor: null,
    NombreConductor: null,
    NombreEmpresa: "ESENTTIA",
    NombreTranspo: null,
    Origen: null,
    PlacaTrailer: null,
    PlacaTruck: "UFV131",
    Ref: "147113",
    Speed: 0,
    StreamingOn: false,
    StreamingUrl: null,
    Tiempo: "120H 49M",
    TipoReporte: "VALIDACION PUERTO - ENTRADA ",
    allowstream: false,
    bateria: 76,
    bitGPS: false,
    expanded: false,
    fecha: "2026-05-20 13:52:40",
    fechafin: "2026-05-25 15:10:47",
    fechainicio: "2026-05-20 13:52:40",
    geocerca: "ESENTTIA - Mamonal",
    icon_bat: "images/batt-med1.png",
    iconmapcenter: "abierto_detenido",
    mostrargeocerca: 1,
    pos: "10.4069,-75.5271",
    tiempoUnix: 1779304896,
    tiempodetencion: "0",
    trayecto: 0,
    username: "",
};

const MOCK_CONTRACTS = [
    {
        ...MOCK_CONTRACT_BASE,
        NombreContrato: "Contrato Logiseguridad",
        Cliente: "Logiseguridad Ltda",
        Estado: "Activo",
        reportes: [
            {
                Id_Reporte: "demo-1",
                NombreReporte: "Trazabilidad Operativa",
                DescripcionReporte: "Vista consolidada del comportamiento operativo del contrato.",
                ReportCategoria: "Operaciones",
                ContractR: -1,
                UltPunto: -1,
                ContratoData: { ...MOCK_CONTRACT_BASE },
            },
            {
                Id_Reporte: "demo-2",
                NombreReporte: "Indicadores de Servicio",
                DescripcionReporte: "Metricas clave para seguimiento de cumplimiento y novedades.",
                ReportCategoria: "Indicadores",
                ContractR: -1,
                UltPunto: -1,
            },
        ],
    },
    {
        ...MOCK_CONTRACT_BASE,
        ContractID: "SERV-00999991",
        NombreContrato: "Contrato Carga Centro",
        Cliente: "Infocarga Demo",
        Estado: "Disponible",
        NombreEmpresa: "ESENTTIA",
        Ref: "DEMO-01",
        reportes: [
            {
                Id_Reporte: "demo-3",
                NombreReporte: "Mapa de Cumplimiento",
                DescripcionReporte: "Seguimiento visual del estado del contrato y sus hitos.",
                ReportCategoria: "Seguimiento",
                ContractR: -1,
                UltPunto: -1,
                ContratoData: {
                    ...MOCK_CONTRACT_BASE,
                    ContractID: "SERV-00999991",
                    Ref: "DEMO-01",
                },
            },
        ],
    },
];

const normalizeText = (value, fallback = "") => String(value ?? fallback).trim();

const getQueryToken = (search) => {
    const params = new URLSearchParams(search);
    return params.get("publicToken") || params.get("token") || "";
};

const getFirstValue = (obj, keys, fallback = null) => {
    for (const key of keys) {
        if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== "") {
            return obj[key];
        }
    }
    return fallback;
};

const buildReportUrl = (report) => getFirstValue(report, [
    "DownloadUrl",
    "downloadUrl",
    "UrlDescarga",
    "urlDescarga",
    "ReportUrl",
    "reportUrl",
    "PublicUrl",
    "publicUrl",
], "");

const normalizeReport = (report, contract) => {
    const reportId = getFirstValue(report, ["Id_Reporte", "id", "Id"], "");

    return {
        ...report,
        contractId: getFirstValue(contract, ["id", "contractId", "ContractID", "Contrato"], ""),
        reportId,
        title: getFirstValue(report, ["NombreReporte", "nombre", "title", "Titulo"], "Reporte"),
        description: getFirstValue(
            report,
            ["DescripcionReporte", "descripcion", "description", "Detalle"],
            "Reporte disponible para consulta."
        ),
        category: getFirstValue(report, ["ReportCategoria", "categoria", "Categoria"], "General"),
        downloadUrl: buildReportUrl(report),
        viewerUrl: getFirstValue(report, ["ViewerUrl", "viewerUrl", "EmbedUrl", "embedUrl"], ""),
        ultPunto: getFirstValue(report, ["UltPunto", "ultPunto", "ultimoPunto", "UltimoPunto"], -1),
        contractR: getFirstValue(report, ["ContractR", "contractR", "ultRecorrido", "UltRecorrido"], -1),
        contractData: getFirstValue(report, ["ContratoData", "contratoData", "Contrato", "contrato", "InfoContrato"], null),
        endpointOverrides: {
            getFotos: getFirstValue(report, ["EndpointFotos", "endpointFotos", "getFotosEndpoint"], ""),
            getReportestrafico: getFirstValue(report, ["EndpointReportesTrafico", "endpointReportestrafico", "getReportestraficoEndpoint"], ""),
            getInfoAditionalContrato: getFirstValue(report, ["EndpointVisualLogistic", "endpointInfoAditionalContrato", "getInfoAditionalContratoEndpoint"], ""),
            getReportesdevice: getFirstValue(report, ["EndpointReportesDevice", "endpointReportesdevice", "getReportesdeviceEndpoint"], ""),
            getReportesdeviceValitronics: getFirstValue(report, ["EndpointReportesDeviceValitronics", "endpointReportesdeviceValitronics", "getReportesdeviceValitronicsEndpoint"], ""),
            getInfoContrato: getFirstValue(report, ["EndpointInfoContrato", "endpointInfoContrato", "getInfoContratoEndpoint"], ""),
            getInfoContratoFake: getFirstValue(report, ["EndpointInfoContratoFake", "endpointInfoContratoFake", "getInfoContratoFakeEndpoint"], ""),
        },
    };
};

const normalizeContract = (contract, index) => {
    const contractId = normalizeText(
        getFirstValue(contract, ["ContractID", "contractId", "Contrato", "id"], `contrato-${index + 1}`)
    );
    const reportsSource = getFirstValue(contract, ["reports", "reportes", "children", "Reportes"], []);

    return {
        ...contract,
        sourceData: contract,
        contractId,
        contractName: normalizeText(
            getFirstValue(contract, ["NombreContrato", "contractName", "name", "Cliente"], contractId),
            contractId
        ),
        customer: normalizeText(
            getFirstValue(contract, ["Cliente", "Empresa", "companyName", "RazonSocial"], "Sin cliente")
        ),
        status: normalizeText(
            getFirstValue(contract, ["EstadoServicio", "Estado", "status"], "Disponible")
        ),
        reports: Array.isArray(reportsSource)
            ? reportsSource.map((report) => normalizeReport(report, contract))
            : [],
    };
};

const normalizeContracts = (payload) => {
    const rawContracts = getFirstValue(payload, ["contratos", "contracts", "data"], payload);

    if (Array.isArray(rawContracts) && rawContracts.every((item) => Array.isArray(item?.reportes) || Array.isArray(item?.reports))) {
        return rawContracts.map(normalizeContract);
    }

    if (Array.isArray(rawContracts)) {
        const grouped = rawContracts.reduce((acc, item, index) => {
            const contractId = normalizeText(
                getFirstValue(item, ["ContractID", "contractId", "Contrato", "ContratoId"], `contrato-${index + 1}`)
            );

            if (!acc[contractId]) {
                acc[contractId] = {
                    ...item,
                    ContractID: contractId,
                    NombreContrato: getFirstValue(item, ["NombreContrato", "Cliente", "contractName"], contractId),
                    Cliente: getFirstValue(item, ["Cliente", "Empresa", "companyName"], "Sin cliente"),
                    Estado: getFirstValue(item, ["EstadoServicio", "Estado", "status"], "Disponible"),
                    reportes: [],
                };
            }

            acc[contractId].reportes.push(item);
            return acc;
        }, {});

        return Object.values(grouped).map(normalizeContract);
    }

    return [];
};

const buildContractFromPublicAccess = (payload) => {
    const accessData = payload?.data || payload || {};
    const contractId = normalizeText(
        getFirstValue(accessData, ["contrato", "ContractID", "contractId", "Contrato"], ""),
        ""
    );

    if (!contractId) {
        return null;
    }

    const baseContract = {
        ...accessData,
        Active: getFirstValue(accessData, ["activo", "Active", "active"], true),
        ContractID: contractId,
        NombreConductor: getFirstValue(accessData, ["conductor", "NombreConductor", "driver"], ""),
        PlacaTruck: getFirstValue(accessData, ["placa", "PlacaTruck", "plate"], ""),
        NombreEmpresa: getFirstValue(accessData, ["cliente", "NombreEmpresa", "Empresa"], ""),
    };

    return {
        ...baseContract,
        sourceData: accessData,
        contractId,
        contractName: contractId,
        customer: normalizeText(
            getFirstValue(accessData, ["cliente", "NombreEmpresa", "Empresa"], "Sin cliente")
        ),
        status: getFirstValue(accessData, ["activo", "Active", "active"], true) ? "Activo" : "Inactivo",
        reports: [
            {
                reportId: `public-${contractId}`,
                title: "Reporte de servicio",
                description: "Consulta publica del contrato validado por token.",
                category: "Publico",
                downloadUrl: "",
                viewerUrl: "",
                ultPunto: -1,
                contractR: -1,
                contractData: baseContract,
                endpointOverrides: {},
            },
        ],
    };
};

const buildPreviewContract = (contract, report) => {
    const source = report?.contractData && typeof report.contractData === "object"
        ? report.contractData
        : contract?.sourceData || contract || {};

    return {
        ...source,
        ContractID: getFirstValue(source, ["ContractID", "contractId", "Contrato"], contract?.contractId || ""),
        NombreEmpresa: getFirstValue(source, ["NombreEmpresa", "Cliente", "Empresa"], contract?.customer || ""),
        DescripcionRuta: getFirstValue(source, ["DescripcionRuta", "Ruta"], source?.DescripcionRuta || ""),
        FKLokDeviceID: getFirstValue(source, ["FKLokDeviceID", "Dispositivo"], source?.FKLokDeviceID || ""),
        NombreConductor: getFirstValue(source, ["NombreConductor", "Conductor"], source?.NombreConductor || ""),
        MovilConductor: getFirstValue(source, ["MovilConductor", "Celular"], source?.MovilConductor || ""),
        PlacaTruck: getFirstValue(source, ["PlacaTruck", "PlacaCabezote"], source?.PlacaTruck || ""),
        PlacaTrailer: getFirstValue(source, ["PlacaTrailer", "PlacaRemolque"], source?.PlacaTrailer || ""),
        NombreTranspo: getFirstValue(source, ["NombreTranspo", "Transportador"], source?.NombreTranspo || ""),
        ContainerNum: getFirstValue(source, ["ContainerNum", "Contenedor"], source?.ContainerNum || ""),
        Ref: getFirstValue(source, ["Ref", "Referencia"], source?.Ref || ""),
        fecha: getFirstValue(source, ["fecha", "FechaInicioServicio", "InicioServicio"], source?.fecha || ""),
        fechafin: getFirstValue(source, ["fechafin", "FechaFinServicio", "FinalServicio"], source?.fechafin || ""),
    };
};

const ReportViewer = ({ contract, report, isPreviewMode, publicToken }) => {
    if (!report) {
        return (
            <div className="public-reportes__empty-viewer">
                <FaFileAlt size={28} />
                <h4>Reporte no disponible</h4>
                <p>No se encontró un reporte válido para este enlace.</p>
            </div>
        );
    }

    const previewContract = buildPreviewContract(contract, report);

    if (!previewContract?.ContractID) {
        return (
            <div className="public-reportes__empty-viewer">
                <FaFileAlt size={28} />
                <h4>Reporte sin contrato asociado</h4>
                <p>El backend debe enviar la informacion del contrato necesaria para renderizar el reporte consolidado.</p>
            </div>
        );
    }

    return (
        <div className="public-reportes__consolidated-preview">
            {isPreviewMode && !localStorage.getItem("tkn") && (
                <div className="public-reportes__preview-note">
                    Vista de prueba sin token. El consolidado usara este mismo componente cuando el backend publico entregue los datos reales.
                </div>
            )}

            <div className="public-reportes__consolidated-frame">
                <ReporteServicioPublico
                    key={`${previewContract.ContractID}-${report.reportId}-${report.contractR}-${report.ultPunto}`}
                    contrato={previewContract}
                    ultPunto={report.ultPunto ?? -1}
                    contractR={report.contractR ?? -1}
                    publicToken={publicToken}
                    endpointOverrides={report.endpointOverrides}
                    setContainerRef={() => { }}
                />
            </div>
        </div>
    );
};

export default function PublicReportes() {
    const { publicToken: routePublicToken } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const publicToken = routePublicToken || getQueryToken(location.search);

    const [contracts, setContracts] = useState([]);
    const [selectedContractId, setSelectedContractId] = useState("");
    const [selectedReportId, setSelectedReportId] = useState("");
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [isPreviewMode, setIsPreviewMode] = useState(false);

    const selectedContract = useMemo(
        () => contracts.find((contract) => contract.contractId === selectedContractId) || null,
        [contracts, selectedContractId]
    );

    const selectedReport = useMemo(
        () => selectedContract?.reports?.find((report) => String(report.reportId) === String(selectedReportId)) || null,
        [selectedContract, selectedReportId]
    );

    useEffect(() => {
        document.documentElement.classList.add("public-reportes-page");
        document.body.classList.add("public-reportes-page");

        return () => {
            document.documentElement.classList.remove("public-reportes-page");
            document.body.classList.remove("public-reportes-page");
        };
    }, []);

    useEffect(() => {
        const loadPublicReports = async () => {
            if (!publicToken) {
                const previewContracts = normalizeContracts(MOCK_CONTRACTS);
                setContracts(previewContracts);
                setSelectedContractId(previewContracts[0]?.contractId || "");
                setSelectedReportId(previewContracts[0]?.reports?.[0]?.reportId || "");
                setIsPreviewMode(true);
                setLoading(false);
                return;
            }

            // TODO: Eliminar esta sección de código de prueba que simula un error para validar la UI de error sin necesidad de un backend configurado.
            // const server = process.env.REACT_APP_SERVER;
            const server = `https://alertas.cargotronics.com/api`;

            if (!server) {
                setErrorMessage("No esta configurada la URL del backend.");
                setLoading(false);
                return;
            }

            setLoading(true);
            setErrorMessage("");
            setIsPreviewMode(false);

            let lastError = null;

            try {
                const response = await axios.post(
                    `${server}${PUBLIC_TOKEN_ENDPOINT}`,
                    JSON.stringify({ publicToken }),
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    }
                );
                console.log("Respuesta del servidor para token público:", response?.data);

                if (response?.data?.success !== true) {
                    throw new Error(response?.data?.message || "Token invalido");
                }

                const normalizedContracts = normalizeContracts(response?.data?.data ?? response?.data);

                if (normalizedContracts.length) {
                    setContracts(normalizedContracts);
                    setSelectedContractId(normalizedContracts[0].contractId);
                    setSelectedReportId(normalizedContracts[0].reports?.[0]?.reportId || "");
                    setLoading(false);
                    return;
                }

                const publicAccessContract = buildContractFromPublicAccess(response?.data);

                if (!publicAccessContract) {
                    throw new Error("El token fue valido, pero no llegaron datos suficientes para continuar con el reporte.");
                }

                setContracts([publicAccessContract]);
                setSelectedContractId(publicAccessContract.contractId);
                setSelectedReportId(publicAccessContract.reports[0]?.reportId || "");
                setLoading(false);
                return;
            } catch (error) {
                lastError = error;
            }

            setErrorMessage(
                lastError?.response?.data?.message ||
                lastError?.message ||
                "No fue posible validar el token de acceso."
            );
            setLoading(false);
        };

        loadPublicReports();
    }, [publicToken]);

    const handleDownload = (report) => {
        const downloadUrl = report?.downloadUrl || report?.viewerUrl;

        if (!downloadUrl) {
            Swal.fire({
                title: "Descarga no disponible",
                text: "Este reporte no tiene una URL de descarga configurada.",
                icon: "info",
                confirmButtonText: "Cerrar",
            });
            return;
        }

        window.open(downloadUrl, "_blank", "noopener,noreferrer");
    };

    const handleCloseModal = () => {
        if (window.history.length > 1) {
            navigate(-1);
            return;
        }
        navigate("/");
    };

    if (loading) {
        return (
            <div className="public-reportes">
                <div className="public-reportes__status-card">
                    <div className="spinner-border text-primary" role="status" />
                    <h3>Validando acceso</h3>
                    <p>Estamos consultando los contratos y reportes asociados a este enlace.</p>
                </div>
            </div>
        );
    }

    if (errorMessage) {
        return (
            <div className="public-reportes">
                <div className="public-reportes__status-card public-reportes__status-card--error">
                    <h3>Enlace no disponible</h3>
                    <p>{errorMessage}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="public-reportes">
            <ModalReporteServicio
                isOpen={true}
                onClose={handleCloseModal}
                showCloseButton={false}
                keyboardEnabled={false}
                bodyClassName="bg-white"
                childComponent={
                    <ReportViewer
                        contract={selectedContract}
                        report={selectedReport}
                        isPreviewMode={isPreviewMode}
                        publicToken={publicToken}
                    />
                }
            />
        </div>
    );
}
